<template>
    <div>
        <div class="downloadContent">
            <div class="downloadInfo">
                <div class="searchInput">
                    <div class="searchText">
                        <i></i>
                        <form action="" id="myform">
                            <input id="inputText" type="serch" v-model="input" @focus="focusShow=true" @keypress="searchGoods" placeholder="搜索网盘文件">
                        </form>
                        <span v-if="removeShow" @click="clearText"></span>
                    </div>
                    <div class="cecalBtn" v-if="focusShow" @click="cancelSearch">取消</div>
                </div>
            </div>
            <div class="downloadBox">
                <div class="downloadTitle">
                    <h2 v-if="title"><span v-for="(item,i) in newArr" :key="i">{{item}} <i v-if="i!=0&&i!=newArr.length-1">></i></span></h2>
                    <p v-else>搜索结果（{{searchCount}}）</p>
                    <div class="chooseAll">
                        <div class="check" @click="checkAllFun()">
                            <span v-if="list.length>0&&!checkAllShow"><input type="checkbox" :checked="checkAll"/><label for=""></label></span>
                        </div>
                        <span style="color:#9DA4B3;">全选</span>
                    </div>
                </div>
                <div class="downloadList">
                    <ul>
                        <li v-for="(item,index) in list" :key="index" :id="'download_'+index">
                            <div class="url" v-if="item.ext==='url'">
                                <a :href="item.dlurl">
                                    <div class="filesImg">
                                        <i v-if="item.ext==='word'" class="word-icon"></i>
                                        <i v-else-if="item.ext==='pdf'" class="pdf-icon"></i>
                                        <i v-else-if="item.ext==='txt'" class="txt-icon"></i>
                                        <i v-else-if="item.ext==='jpg'||item.ext==='png'" class="img-icon"></i>
                                        <i v-else-if="item.ext==='mp4'" class="mp4-icon"></i>
                                        <i v-else-if="item.ext==='docx'" class="docx-icon"></i>
                                        <i v-else-if="item.ext==='url'" class="url-icon"></i>
                                        <i v-else class="other-icon"></i>
                                    </div>
                                    <div class="rightText">
                                        <div class="centerName">
                                            <h3>{{item.oldfilename}}</h3>
                                            <div class="downloadCount nocheck">
                                                <span v-if="item.dlpv">下载次数：{{item.dlpv}}次</span>
                                                <span v-else>下载次数：0次</span>
                                                <span v-if="item.length">{{bytesToSize(item.length)}}</span>
                                                <span v-else>0 KB</span>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div v-else-if="!item.isdir">
                                <div class="filesImg">
                                    <i v-if="item.ext==='word'" class="word-icon"></i>
                                    <i v-else-if="item.ext==='pdf'" class="pdf-icon"></i>
                                    <i v-else-if="item.ext==='txt'" class="txt-icon"></i>
                                    <i v-else-if="item.ext==='jpg'||item.ext==='png'" class="img-icon"></i>
                                    <i v-else-if="item.ext==='mp4'" class="mp4-icon"></i>
                                    <i v-else-if="item.ext==='docx'" class="docx-icon"></i>
                                    <i v-else-if="item.ext==='url'" class="url-icon"></i>
                                    <i v-else class="other-icon"></i>
                                </div>
                                <div class="rightText">
                                    <div class="centerName">
                                        <h3>{{item.oldfilename}}</h3>
                                        <div class="downloadCount">
                                            <span v-if="item.dlpv">下载次数：{{item.dlpv}}次</span>
                                            <span v-else>下载次数：0次</span>
                                            <span v-if="item.length">{{bytesToSize(item.length)}}</span>
                                            <span v-else>0 KB</span>
                                        </div>
                                    </div>
                                    <div class="check">
                                        <span><input type="checkbox" :checked="item.isCheck" :id="index" @click="checkOne(item)"/><label :for="index"></label></span>
                                    </div>
                                </div>
                            </div>
                            <div v-else @click="getMore(item)">
                                <div class="filesImg">
                                    <i v-if="item.ext==='word'" class="word-icon"></i>
                                    <i v-else-if="item.ext==='pdf'" class="pdf-icon"></i>
                                    <i v-else-if="item.ext==='txt'" class="txt-icon"></i>
                                    <i v-else-if="item.ext==='jpg'||item.ext==='png'" class="img-icon"></i>
                                    <i v-else-if="item.ext==='mp4'" class="mp4-icon"></i>
                                    <i v-else-if="item.ext==='docx'" class="docx-icon"></i>
                                    <i v-else-if="item.ext==='url'" class="url-icon"></i>
                                    <i v-else class="other-icon"></i>
                                </div>
                                <div class="rightText">
                                    <div class="centerName">
                                        <h3>{{item.oldfilename}}</h3>
                                        <div class="downloadCount nocheck">
                                            <span v-if="item.dlpv">下载次数：{{item.dlpv}}次</span>
                                            <span v-else>下载次数：0次</span>
                                            <span v-if="item.length">{{bytesToSize(item.length)}}</span>
                                            <span v-else>0 KB</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="searchCount==0&&!title">
                    <p style="text-align:center;">暂无数据</p>
                </div>
            </div>
            <div class="bottomBtn">
                <div class="shareBtn" v-if="downloadShow" @click="downloadFun"><i></i><span>下载</span></div>
            </div>  
        </div>
    </div>
</template>
<script>
import http from '../common/http.js'
export default {
    data(){
        return{
            shareShow:false,
            removeShow:false,
            checkAll:false,
            list:[],
            num:0,
            input:"",
            focusShow:false,
            title:'',
            newArr:[],
            searchCount:0,
            downloadShow:false,
            checkAllShow:false,
        }
    },
    mounted() {
        this.input=this.$route.query.searchName
        this.title=this.$route.query.name
        if(this.title){
            this.getFiles()
        }else{
            this.searchFiles()
        }
        if(this.title){
            this.newArr=this.title.split('/')
        }
    },
    methods:{
        searchGoods(event){
            if(event.keyCode == 13){
                event.preventDefault()
                document.getElementById('inputText').blur()
                if(this.input!=''){
                    this.title=''
                    this.checkAll=false
                    this.downloadShow=false
                    this.searchFiles()
                }
            }
        },
        getFiles(){
            this.$indicator.open("加载中...")
            http.get('mobile/getfilesbydir?name='+this.title).then(res=> {
                this.$indicator.close()
                if(res.ok){
                    this.list=res.data
                    let flag=false,arr=[]
                    this.list.forEach((val)=>{
                        val.isCheck=false
                        if(val.isdir){
                            flag=true
                        }
                        if(flag){
                            arr.push(val)
                        }
                    })
                    if(this.list.length==arr.length){
                        this.checkAllShow=true
                    }
                }else{
                    this.$toast({
                        message: res.message,
                        duration: 2000
                    });
                }
            }).catch(err=> {
                console.log(err)
            });
        },
        getMore(item){
            this.checkAllShow=false
            this.$indicator.open("加载中...")
            http.get('mobile/getfilesbydir?name='+item.dirindex+'&isdir=1').then(res=> {
                this.$indicator.close()
                if(res.ok){
                    this.list=res.data
                    this.list.forEach((val)=>{
                        val.isCheck=false
                    })
                }else{
                    this.$toast({
                        message: res.message,
                        duration: 2000
                    });
                }
            }).catch(err=> {
                console.log(err)
            });
        },
        searchFiles(){
            this.$indicator.open("加载中...")
            http.get('mobile/searchfile?name='+this.input).then(res=> {
                this.$indicator.close()
                if(res.ok){
                    this.list=res.data
                    this.list.forEach((val)=>{
                        val.isCheck=false
                    })
                    this.searchCount=this.list.length
                }else{
                    this.$toast({
                        message: res.message,
                        duration: 2000
                    });
                }
            }).catch(err=> {
                console.log(err)
            });
        },
        clearText(){
            this.input=''
            this.focusShow=false
        },
        cancelSearch(){
            this.input=''
            this.focusShow=false
        },
        checkOne(item){
            item.isCheck=!item.isCheck
            this.downloadShow=item.isCheck
            this.list.forEach((val)=>{
                if(val.isCheck){
                    this.downloadShow=true
                    this.num++;
                    if(this.list.length==this.num){
                        this.checkAll=true
                    }
                }else{
                    this.num=0
                    this.checkAll=false
                }
            })
        },
        checkAllFun(){
            this.checkAll=!this.checkAll
            this.downloadShow=this.checkAll
            this.list.forEach((val)=>{
                val.isCheck=this.checkAll
            })
        },
        downloadFun(){
            let flag=false
            this.list.forEach((val)=>{
                if(val.isCheck){
                    flag=true
                }
            })
            if(!flag){
                this.$toast({
                    message: '请先勾选要下载的文件',
                    duration: 2000
                });
            }else{
                let u = navigator.userAgent;
                let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
                if(isIOS){
                    this.list.forEach((val)=>{
                        if(val.isCheck){
                            if(val.dlurl!==undefined){
                                window.open(val.dlurl)
                                // this.newWin(val.dlurl)
                            }
                        }
                    })
                }else{
                    let arr=[]
                    this.list.forEach((val)=>{
                        if(val.isCheck){
                            if(val.dlurl!==undefined){
                                arr.push(val.dlurl)
                            }
                        }
                    })
                    this.multipleDown(arr)
                }

            }
        },
        newWin(url){      //Android和IOS都只能下载单文件
            var a = document.createElement("a")
            a.setAttribute('href',url)
            a.setAttribute('style','display:none')
            a.setAttribute('target','_blank')
            document.body.appendChild(a)
            a.click()
            a.parentNode.removeChild(a)
        },
        multipleDown(downloadUrls){    //支持Android在浏览器打开多选下载
            let length=downloadUrls.length
            for (let i in downloadUrls) {
                let adress = downloadUrls[i];
                setTimeout(()=> {
                    let frame = document.createElement("iframe");
                    frame.setAttribute("id", "iframe_" + i);
                    frame.src = adress;
                    document.body.appendChild(frame);
                    setTimeout(()=> {
                        document.body.removeChild(frame);
                    }, length*1000);
                }, 100);
            }
        },
        // shareFun(){
        //     let userAgent=navigator.userAgent
        //     if(userAgent.indexOf('MQQBrowser')!=-1||userAgent.indexOf('UCBrowser')!=-1){
        //         let mshare = new mShare({
        //             title: '凯儿得乐素材库',
        //             url: 'http://mtc.hkaspire.net',
        //             desc: '凯儿得乐品牌创立起源于母爱，成就于责任',
        //             img: 'http://mo.caredaily.com/static/img/logo4.3600e5e.png'
        //         });
        //         mshare.init(0)
        //     }else{
        //         this.$toast({
        //             message: '该浏览器不支持分享功能，请使用QQ浏览器或UC浏览器',
        //             duration: 3000
        //         });
        //     }
        // },
        // 计算字节
        bytesToSize(bytes){
            if(bytes===0) return '0 B'
            let k = 1024,
            sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
            return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
        },
    },
    watch:{
        input(){
            if(this.input){
                this.removeShow=true
                this.focusShow=true
            }else{
                this.removeShow=false
                this.focusShow=false
            }
        },
    }
}
</script>
<style scope lang="scss">
.downloadBox{
    padding-bottom: 1.8rem;
}
.downloadTitle{
    padding: 0 .24rem 0 .56rem;
    height: .96rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h2{
        font-size: .4rem;
        flex: 1;
        margin-top: -.1rem;
        span{
            font-size: .24rem;
            color: #9DA4B3;
            font-weight: 300;
            &:last-child{
                color: #000;
            }
        }
    }
    p{
        line-height: .96rem;
        font-size: .24rem;
        color: #000;
    }
    .chooseAll{
        width: 1rem;
        display: flex;
        align-items: center;
    }
}

.downloadList{
    padding-left: .24rem;
    ul li>div{
        padding:.24rem 0 0 .24rem ;
        display: flex;
        align-items: center;
        a{
            display: block;
            width: 100%;
            display: flex;
            align-items: center;
        }
        .filesImg{
            width: .56rem;
            margin-right: .18rem;
            i{
                display: block;
                width: .56rem;
                height: .56rem;
                &.word-icon{
                    background: url(../image/Lb_Icon_Word@2x.png) no-repeat;
                    background-size: contain;
                }
                &.pdf-icon{
                    background: url(../image/Lb_Icon_Pdf@2x.png) no-repeat;
                    background-size: contain;
                }
                &.txt-icon{
                    background: url(../image/Lb_Icon_Txt@2x.png) no-repeat;
                    background-size: contain;
                }
                &.other-icon{
                    background: url(../image/Lb_Icon_Wjj@2x.png) no-repeat;
                    background-size: contain;
                }
                &.img-icon{
                    background: url(../image/Lb_Icon_Img@2x.png) no-repeat;
                    background-size: contain;
                }
                &.mp4-icon{
                    background: url(../image/Lb_Icon_Ship@2x.png) no-repeat;
                    background-size: contain;
                }
                &.docx-icon{
                    background: url(../image/Lb_Icon_Word@2x.png) no-repeat;
                    background-size: contain;
                }
                &.url-icon{
                    background: url(../image/url.png) no-repeat;
                    background-size: contain;
                }
            }
        }
        .leftCheck{
            margin-right: .2rem;
        }
        .rightText{
            display: flex;
            padding-right: .3rem;
            width: 100%;
            height: 100%;
            border-bottom: 1px solid #F3F4F6;
            align-items: center;
            padding-bottom: .22rem;
            overflow: hidden;
            .centerName{
                flex: 1;
                overflow: hidden;
                word-wrap:break-word;
                h3{
                    font-size: .3rem;
                    font-size: #000;
                }
                .downloadCount{
                    color: #9DA4B3;
                    width: 100%;
                    span:nth-child(2){
                        float: right;
                        margin-right: .8rem;
                    }
                }
                .nocheck span:nth-child(2){
                    margin-right: 1.2rem!important;
                }
            }
        }
    }
}

.downloadInfo{
    padding: .3rem .4rem .14rem;
    box-shadow: 2px 3px 5px #F7F8F9;
}
.bottomBtn{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    // display: flex;
    z-index: 6;
    div{
        // display: flex;
        // flex: 1;
        // line-height: 1.2rem;
        height: 100%;
        text-align: center;
        color: #fff;
        font-size: .28rem;
        background: #79ACFF;
        // align-items: center;
        // justify-content: center;
        &:nth-child(2){
            background: #FF7979;
        }
    }
    i{
        display: block;
        width:.44rem;
        height:.44rem;
    }
    .shareBtn{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        i{
            background: url(../image/Xz@2x.png) no-repeat;
            background-size: contain;
            margin-bottom: .1rem;
        }
        span{
            font-size: .2rem;
        }
    } 
    .downloadBtn i{
        background: url(../image/Xz@2x.png) no-repeat;
        background-size: contain;
    }
}
.popupBox{
    width: 100%;
    padding-top: .12rem;
    img{
        width: .74rem;
        height: .74rem;
        margin: .4rem auto 0;
    }
    p{
        font-size: .28rem;
        color: #929292;
    }
}

.check{
    width: 24px;
    display: flex;
    align-items: center;
    span{
        position: relative;
        input{
            position: absolute;
            visibility: hidden;
        }
        input+label{
            display: inline-block;
            width: .4rem;
            height: .4rem;
            background:url("../image/Fz_Xz@2x.png") no-repeat;
            background-size:contain;
            margin-top: 0.09rem;
        }
        input:checked+label{
            display: inline-block;
            width: .4rem;
            height: .4rem;
            background:url("../image/Fz_Xz_Click@2x.png") no-repeat;
            background-size:contain;
            margin-top: 0.09rem;
        }
    }
}
</style>


